import { useLocation as _useLocation, useHistory } from 'react-router-dom';

import { Path } from 'constants/routing';
import { useAppDispatch } from 'store/store-hooks';
import { setSnapshot, setCameFrom } from 'components/app/_mediator/memory/memory.slice';
import { useZoomCb } from 'components/app/_mediator/zoom/use-zoom-cb';
import { setRecentAction } from 'components/app/_mediator/app-logger.slice';

export const useLocation = () => {
  const { pathname, search } = _useLocation();
  return { path: pathname as Path, search };
};

export const useAppNavigator = () => {
  const { takeSnapshot } = useZoomCb();
  const history = useHistory();
  const dispatch = useAppDispatch();

  /* PATTERN: Middleware */

  const navigateTo = (nextPath: Path, params?: string) => {
    const currentPath = getPath();
    if (currentPath !== nextPath) {
      dispatch(setCameFrom(currentPath));
      dispatch(setRecentAction({ key: 'NAV', desc: currentPath + ' -> ' + nextPath }));
      if (currentPath !== Path.projects) {
        dispatch(setSnapshot(takeSnapshot(), currentPath));
      }
      history.push(nextPath + (params ?? ''));
    }
  };
  return { navigateTo };
};

export const useAuthNavigator = () => {
  const history = useHistory();
  const navigateTo = (nextPath: Path, params?: string) => {
    history.push(nextPath + (params ?? ''));
  };
  return { navigateTo };
};

export const getPath = () => {
  return window.location.pathname as Path;
};

export { Path };
